// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__1PGJ1","title":"ClientInsurance_title__12HY9","itemText":"ClientInsurance_itemText__16WaF"};